import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { connect } from 'react-redux';

//import { uploadBuyFormData } from '../components/forms/TwoColBuyFormWithIllustrationFullForm'



const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
const Select = tw.select`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`
/*const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24`}
`
*/
const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`

const TCCUWIFFComponent = (props) => {

  const data = props.BFData;
  
  const [ selectState, setSelectState ] = useState();
  
  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={data.EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={data.textOnLeft}>
          <TextContent>
            {data.subheading && <Subheading>{data.subheading}</Subheading>}
            <Heading>{data.heading}</Heading>
            {data.description && <Description>{data.description}</Description>}
            <Form action='/blog' method='GET'>
            <Input type='hidden' name='dataToRender' value='Foods' />
              {/*data.formInputData.map((d, i) => <Input key={i} type={d.type} name={d.name} placeholder={d.placeholder} />)*/}              
              <Select name="cat" onChange={(e) => setSelectState(e.target.value)} required>
			          <option value="">Select Item Category</option>
			          {Object.keys(data.formSelectCategoryData).map((d, i) => <option key={i} value={d}>{data.formSelectCategoryData[d].name}</option>)}
			        </Select>
              <Select name="prod_type" required>
			          <option value="">Select Item</option>
			          {selectState && data.formSelectCategoryData[selectState]?.items?.map((d, i) => <option key={i} value={d}>{d}</option>)}
			        </Select>              
              <SubmitButton type="submit">{data.submitButtonText}</SubmitButton>
            </Form>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};

const BuyForm = connect((state) => ({
  BFData: state.BuyFormData
}))(TCCUWIFFComponent);

export default BuyForm;